import { useEffect, useState } from "react";

function isValidDiscount(discount) {
	if (!discount) return false;

	// Normalize string too se if its dicount 0
	const normalized = String(discount).trim();

	// Temporary backend workaround - discount should never be truthy
	if (normalized === "0%" || normalized === "0") return false;

	return true;
}

export function useOrderDiscount({ profileId, orderId }) {
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (!profileId || !orderId) return;

		let cancelled = false;

		async function fetchOrderPricing() {
			setIsLoading(true);

			try {
				const baseUrl = process.env.GATSBY_FETCH_DISCOUNT_ENDPOINT;

				if (!baseUrl) {
					throw new Error("GATSBY_FETCH_DISCOUNT_ENDPOINT is not defined");
				}

				const response = await fetch(`${baseUrl}/profiles/${profileId}/orders/${orderId}`);

				if (!response.ok) {
					throw new Error(`Order pricing request failed (${response.status})`);
				}

				const result = await response.json();

				if (!cancelled) {
					setData(result);
				}
			} catch (error) {
				console.error("[useOrderDiscount]", error);
			} finally {
				if (!cancelled) {
					setIsLoading(false);
				}
			}
		}

		fetchOrderPricing();

		return () => {
			cancelled = true;
		};
	}, [profileId, orderId]);

	const discount = data?.discount ?? null;
	const hasDiscount = isValidDiscount(discount);

	return {
		discount: hasDiscount ? discount : null,
		hasDiscount,
		total: data?.total ?? null,
		isLoading,
	};
}
